export { default } from "./patientAcknowledgmentDialog";
